import React from 'react'
import classnames from 'classnames'
import { useFilters } from '../../context/FiltersContext'
import { DimensionFilter } from "../../types/FiltersTypes"
import { DimensionFilters } from "./DimensionFilters"

interface Props {
  dimensions: DimensionFilter[]
}

export const DimensionFiltersContent: React.FC<Props> = ({ dimensions }) => {
  const { activeCategories, toggleCategory } = useFilters()

  const category = 'dimensions'
  const active = activeCategories.has(category)

  const className = classnames('refineby-filters', `__${category}`, {
    __active: active,
  })

  const toggle = () => toggleCategory(category)

  return (
    <div key={category} className={className}>
      <p data-type={category} onClick={toggle} className="refineby-subtitle">
        Dimensions
      </p>
      <div data-type={category} className="refineby-filterwrap">
        <DimensionFilters dimensions={dimensions} />
      </div>
    </div>
  )
}
